try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/GRIM_REAPER_138_C_MIN.mp3?v=1770726642",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/NORTH_MEMPHIS_140_A_MIN.mp3?v=1770726641",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/IN_THE_MONEY_147_A_MIN.mp3?v=1770726641",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/BREAK_A_HOE_155_F_MIN.mp3?v=1770726641"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/GRIM_REAPER_138_C_MIN.json?v=1770726639",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/NORTH_MEMPHIS_140_A_MIN.json?v=1770726640",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/IN_THE_MONEY_147_A_MIN.json?v=1770726640",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/BREAK_A_HOE_155_F_MIN.json?v=1770726640"
  ];

  const elements = document.querySelectorAll('#player-set-4 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/GRIM_REAPER_138_C_MIN.mp3?v=1770726642",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/NORTH_MEMPHIS_140_A_MIN.mp3?v=1770726641",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/IN_THE_MONEY_147_A_MIN.mp3?v=1770726641",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/BREAK_A_HOE_155_F_MIN.mp3?v=1770726641"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/GRIM_REAPER_138_C_MIN.json?v=1770726639",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/NORTH_MEMPHIS_140_A_MIN.json?v=1770726640",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/IN_THE_MONEY_147_A_MIN.json?v=1770726640",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/BREAK_A_HOE_155_F_MIN.json?v=1770726640"
  ];

  const elements = document.querySelectorAll('#player-set-11412 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/STREET_KINGZ_147_C_MIN.mp3?v=1770726998",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/SHOWTIME_159_E_MIN.mp3?v=1770726998",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/WALK_DOWN_141_D_MIN.mp3?v=1770726998",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/FCK_EM_UP_160_E_MIN.mp3?v=1770726999"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/STREET_KINGZ_147_C_MIN.json?v=1770726996",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/SHOWTIME_159_E_MIN.json?v=1770726996",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/WALK_DOWN_141_D_MIN.json?v=1770726996",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/FCK_EM_UP_160_E_MIN.json?v=1770726996"
  ];

  const elements = document.querySelectorAll('#player-set-6 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/RELOOPED_-_MEMPHIS_TRAP_808_4.wav?v=1770727228",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/RELOOPED_-_MEMPHIS_SNARE_3.wav?v=1770727228",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/RELOOPED_-_MEMPHIS_TRAP_FX_2.wav?v=1770727229",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/RELOOPED_-_MEMPHIS_TRAP_HIHAT_5.wav?v=1770727228"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/808_4.json?v=1770727227",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/SNARE_3.json?v=1770727227",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/RELOOPED_-_MEMPHIS_TRAP_FX_2.json?v=1770727227",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/hihat_5.json?v=1770727227"
  ];

  const elements = document.querySelectorAll('#player-set-5 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/vocal_8_147.mp3?v=1770727395",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/vocal_12_154.mp3?v=1770727395",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/vocal_17_139.mp3?v=1770727395",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/vocal_20_150.mp3?v=1770727395"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/vocal_8_147.json?v=1770727394",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/vocal_12_154.json?v=1770727394",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/vocal_17_139.json?v=1770727394",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/vocal_20_150.json?v=1770727394"
  ];

  const elements = document.querySelectorAll('#player-set-7 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/STREET_KINGZ_147_C_MIN.mp3?v=1770726998",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/SHOWTIME_159_E_MIN.mp3?v=1770726998",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/WALK_DOWN_141_D_MIN.mp3?v=1770726998",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/FCK_EM_UP_160_E_MIN.mp3?v=1770726999"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/STREET_KINGZ_147_C_MIN.json?v=1770726996",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/SHOWTIME_159_E_MIN.json?v=1770726996",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/WALK_DOWN_141_D_MIN.json?v=1770726996",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/FCK_EM_UP_160_E_MIN.json?v=1770726996"
  ];

  const elements = document.querySelectorAll('#player-set-114123 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/RELOOPED_-_MEMPHIS_TRAP_808_4.wav?v=1770727228",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/RELOOPED_-_MEMPHIS_SNARE_3.wav?v=1770727228",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/RELOOPED_-_MEMPHIS_TRAP_FX_2.wav?v=1770727229",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/RELOOPED_-_MEMPHIS_TRAP_HIHAT_5.wav?v=1770727228"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/808_4.json?v=1770727227",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/SNARE_3.json?v=1770727227",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/RELOOPED_-_MEMPHIS_TRAP_FX_2.json?v=1770727227",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/hihat_5.json?v=1770727227"
  ];

  const elements = document.querySelectorAll('#player-set-115 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/vocal_8_147.mp3?v=1770727395",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/vocal_12_154.mp3?v=1770727395",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/vocal_17_139.mp3?v=1770727395",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/vocal_20_150.mp3?v=1770727395"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/vocal_8_147.json?v=1770727394",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/vocal_12_154.json?v=1770727394",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/vocal_17_139.json?v=1770727394",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/vocal_20_150.json?v=1770727394"
  ];

  const elements = document.querySelectorAll('#player-set-117 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
